module.exports = __webpack_public_path__ + "static/img/wdjc1-4.729c84a.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdjc1-4.png
// module id = 883
// module chunks = 0